import { render, staticRenderFns } from "./schoolAddAccount.vue?vue&type=template&id=31f12dd4&scoped=true&"
import script from "./schoolAddAccount.js?vue&type=script&lang=js&"
export * from "./schoolAddAccount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f12dd4",
  null
  
)

export default component.exports